module.exports = __webpack_public_path__ + "img/home30.92e8832d.png";